// Smoothly scrolls the element to the top of the screen, just below the
// sticky page header so the header never covers it.
export const scrollIntoViewBelowHeader = (
  element: HTMLElement | null,
  gap = 16
): void => {
  if (!element) {
    return
  }
  const headerBottom = Math.max(
    document.querySelector('header')?.getBoundingClientRect().bottom ?? 0,
    0
  )
  window.scrollTo({
    top:
      window.scrollY + element.getBoundingClientRect().top - headerBottom - gap,
    behavior: 'smooth'
  })
}
